import { supabase } from "@/integrations/supabase/client";

export interface BlogSettings {
  metaTitle: string;
  metaDescription: string;
  heroTitle: string;
  heroSubtitle: string;
  defaultAuthor: string;
  defaultOgImage: string;
}

const SETTINGS_KEYS: Record<keyof BlogSettings, string> = {
  metaTitle: "blog.meta_title",
  metaDescription: "blog.meta_description",
  heroTitle: "blog.hero_title",
  heroSubtitle: "blog.hero_subtitle",
  defaultAuthor: "blog.default_author",
  defaultOgImage: "blog.default_og_image",
};

const DEFAULT_SETTINGS: BlogSettings = {
  metaTitle: "Blog Toc Toc",
  metaDescription: "Novidades, tendências e inspirações para o mercado imobiliário com a Toc Toc.",
  heroTitle: "Histórias que inspiram novos lares",
  heroSubtitle: "Conteúdo exclusivo com dicas, notícias e boas práticas para o seu dia a dia imobiliário.",
  defaultAuthor: "Equipe Toc Toc",
  defaultOgImage: "",
};

export const blogSettingsService = {
  async getSettings(): Promise<BlogSettings> {
    const keys = Object.values(SETTINGS_KEYS);
    const { data, error } = await supabase
      .from("static_content")
      .select("key, value")
      .in("key", keys);

    if (error) {
      throw error;
    }

    const settingsMap = new Map<string, string>();
    (data || []).forEach(item => {
      settingsMap.set(item.key, item.value ?? "");
    });

    return {
      metaTitle: settingsMap.get(SETTINGS_KEYS.metaTitle) ?? DEFAULT_SETTINGS.metaTitle,
      metaDescription: settingsMap.get(SETTINGS_KEYS.metaDescription) ?? DEFAULT_SETTINGS.metaDescription,
      heroTitle: settingsMap.get(SETTINGS_KEYS.heroTitle) ?? DEFAULT_SETTINGS.heroTitle,
      heroSubtitle: settingsMap.get(SETTINGS_KEYS.heroSubtitle) ?? DEFAULT_SETTINGS.heroSubtitle,
      defaultAuthor: settingsMap.get(SETTINGS_KEYS.defaultAuthor) ?? DEFAULT_SETTINGS.defaultAuthor,
      defaultOgImage: settingsMap.get(SETTINGS_KEYS.defaultOgImage) ?? DEFAULT_SETTINGS.defaultOgImage,
    };
  },

  async updateSettings(settings: Partial<BlogSettings>) {
    const payload = Object.entries(SETTINGS_KEYS)
      .filter(([key]) => settings[key as keyof BlogSettings] !== undefined)
      .map(([key, storageKey]) => ({
        key: storageKey,
        value: (settings[key as keyof BlogSettings] ?? "") as string,
        updated_at: new Date().toISOString(),
      }));

    if (payload.length === 0) {
      return;
    }

    const { error } = await supabase
      .from("static_content")
      .upsert(payload, { onConflict: "key" });

    if (error) {
      throw error;
    }
  },
};
